import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=4d90925b&scoped=true&lang=pug&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90925b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d90925b')) {
      api.createRecord('4d90925b', component.options)
    } else {
      api.reload('4d90925b', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=4d90925b&scoped=true&lang=pug&", function () {
      api.rerender('4d90925b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Tab.vue"
export default component.exports